import { Row } from "antd";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import useAxiosPost from "../../../hooks/useAxiosPost";
import TailSpinLoader from "../../Items/Loaders/TailSpinLoader";
import RedeemedVouchersTable from "../../Items/Table/RedeemedVouchersTable";
import "./../index.css";
const RedeemedVouchersComponent = () => {
  const navigate = useNavigate();
  const [redeemedVouchers, setRedeemedVouchers] = useState<
    RedeemedDiscountVouchersProp[]
  >([]);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("discountVouchers/getRedeemedVouchers");

  useEffect(() => {
    postApiData({});
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      console.log({ data });
      setRedeemedVouchers(data || []);
    }
  }, [apiResponse]);

  return (
    <>
      {apiLoading === true ? (
        <TailSpinLoader />
      ) : (
        <>
          <Row gutter={[16, 16]}>
            <RedeemedVouchersTable vouchers={redeemedVouchers} />
          </Row>
        </>
      )}
    </>
  );
};
export default RedeemedVouchersComponent;
